var ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

var MONTH_NAME = [
  'Januar', // index 0 is not actually used
  'Januar',
  'Februar',
  'Mars',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Desember'
];

function CalendarRN(params) {
  this.params = params;
  this.API = params.api;

  this.calendarList = ko.observableArray([]);

  // Initialize the calendar with the current year and month
  this.currentYear = ko.observable(new Date().getFullYear());
  // Don't want to work with January = 0 --> January should be = 1
  this.currentMonth = ko.observable(new Date().getMonth() + 1);

  // Loading status.
  this.isLoading = ko.observable(false);

  // Only listen to changes in the month. If the year changes, so does the month.
  this.currentMonth.subscribe(function() {
    this.getArticleCalendar();
  }, this);

  // Compute the text combination of month + year to show in the calendar.
  this.monthName = ko.computed(function() {
    return '' + MONTH_NAME[this.currentMonth()];
  }, this);

  this.init();
}

CalendarRN.prototype.init = function() {
  this.getArticleCalendar();
};

// @previous : If we're moving to the previous month or the next month.
CalendarRN.prototype.changeMonth = function(previous) {
  this.isLoading(true);
  var tmpMonth;
  if (previous) {
    tmpMonth = this.currentMonth() - 1;
    // If we wrap around. January -> December
    if (tmpMonth <= 0) {
      this.currentYear(this.currentYear() - 1);
      tmpMonth = 12;
    }
  } else {
    tmpMonth = this.currentMonth() + 1;
    // If we wrap around. December -> January
    if (tmpMonth > 12) {
      this.currentYear(this.currentYear() + 1);
      tmpMonth = 1;
    }
  }
  this.currentMonth(tmpMonth);
};

CalendarRN.prototype.getArticleCalendar = function() {
  var url =
    this.API.articleCalendar +
    '?year=' +
    encodeURIComponent(this.currentYear()) +
    '&month=' +
    encodeURIComponent(this.currentMonth());
  APIHelper.get(
    url,
    function(response) {
      this.calendarList(response.Items);
      this.isLoading(false);
    }.bind(this),
    function() {
      this.isLoading(false);
    }
  );
};

module.exports = CalendarRN;
